
import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import DateRange from '@/components/DateRange.vue';
import api from '@/api';
import Util from '@/utils/util';

const { shoppingGiveBackMerchant } = api;

@Component({
  components: { DateRange },
})
export default class ShoppingGiveBackMerchantList extends Vue {
  private data = { data: [], totalCount: 0, pageSize: 20, pageNo: 0 };

  private loading = false;

  private panel = 0;

  private headers = [
    { text: '合作廠商', value: 'name' },
    { text: '生效日', value: 'startOn' },
    { text: '失效日', value: 'endOn' },
    { text: '狀態', value: 'isEnabled' },
    { text: '動作', value: 'actions' },
  ];

  private get totalCount() {
    return this.data.totalCount;
  }

  private get pageCount() {
    return Math.ceil((this.data.totalCount || 0) / (this.data.pageSize || 20));
  }

  private get collection() {
    return [...(this.data.data || [])];
  }

  private filter = {
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
  };

  private async updatePage(page: number) {
    this.filter.pageNo = page;
    await this.query();
  }

  private async query() {
    const query = {
      ...this.filter,
      pageSize: `${this.filter.pageSize}`,
      pageNo: `${this.filter.pageNo}`,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    }
    await this.requestData();
  }

  private async reset() {
    this.filter = {
      pageSize: 20,
      pageNo: 1,
    };
    await this.query();
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private async requestData() {
    this.loading = true;
    const { data } = await shoppingGiveBackMerchant.list(this.filter);
    this.data = data;
    this.loading = false;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: ShoppingGiveBackMerchantList) => void) | boolean) => void,
  ) {
    await next(async (vm) => {
      await vm.requestData();
    });
  }
}
